import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";

import { defaultSettings, HeadlineSettingsStateType } from "./HeadlineSettingsDialog";

interface HeadlinePreviewProps {
  /**
   * State object represented by series of key value pairs,
   * where the key is a string which represents the title of the
   * updatable settings option.
   */
  settingsState: HeadlineSettingsStateType | {};
}

export default function HeadlinePreview(props: HeadlinePreviewProps) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const currentState = {...defaultSettings, ...props.settingsState};

  return (
    <Stack
      sx={{
        alignItems: "center",
        border: `1px solid ${theme.palette.action.disabled}`,
        borderRadius: theme.general.borderRadius,
        gap: 1,
        justifyContent: "center",
        padding: 2,
        background: currentState.backgroundColor,
        flex: 1,
        height: "35vh",
        width: isSmallScreen ? "100%" : "50%"
      }}>
      <Typography sx={{ color: currentState.headlineColor }} variant="h1">
        {currentState.headlineTitle}
      </Typography>
      <Typography
        variant="h3"
        sx={{
          textAlign: "center",
          fontWeight: "normal",
          color: currentState.subtextColor || theme.palette.text.primary
        }}
      >
        {currentState.headlineSubtext}
      </Typography>
    </Stack>
  );
}